import _ from "underscore";
import { TCommonRowData, TCommonRowObj } from "@ts/common-types";

export const AGGREGATED_COLUMNS: Array<string> = [
    "sale",
    "orders",
    "impression",
    "click",
    "spend",
    "total_impression",
    "total_clicked_ad_sales",
    "total_clicked_ad_units",
    "total_view_ad_units",
    "placement_top_impression",
    "placement_top_spend",
    "placement_top_sale",
    "placement_top_click",
    "placement_top_orders",
    "placement_product_page_impression",
    "placement_product_page_spend",
    "placement_product_page_sale",
    "placement_product_page_click",
    "placement_product_page_orders",
    "placement_rest_impression",
    "placement_rest_spend",
    "placement_rest_sale",
    "placement_rest_click",
    "placement_rest_orders",
    "placement_buybox_impression",
    "placement_buybox_spend",
    "placement_buybox_sale",
    "placement_buybox_click",
    "placement_buybox_orders",
    "placement_homepage_impression",
    "placement_homepage_spend",
    "placement_homepage_sale",
    "placement_homepage_click",
    "placement_homepage_orders",
    "placement_searchingrid_impression",
    "placement_searchingrid_spend",
    "placement_searchingrid_sale",
    "placement_searchingrid_click",
    "placement_searchingrid_orders",
    "placement_stockup_impression",
    "placement_stockup_spend",
    "placement_stockup_sale",
    "placement_stockup_click",
    "placement_stockup_orders",
    "total_impression",
    "total_spend",
    "total_sale",
    "total_click",
    "total_orders",
    "spend_in_adgroup",
];

export const aggregatedSumTotalRow = (currentRows: TCommonRowData) => {
   
    const indexAttribute: Array<string> = [];
    const keys = [
        "spend",
        "sale",
        "orders",
        "click",
        "impression",
        "ctr",
        "cr",
        "cpc",
        "cpa",
        "cpm",
        "acos",
        "roas",
        "troas",
        "total_clicked_ad_sales",
        "total_clicked_ad_units",
        "total_view_ad_units",
        "total_sale",
        "tacos",
        "placement_top_spend",
        "placement_top_sale",
        "placement_top_orders",
        "placement_top_click",
        "placement_top_impression",
        "placement_top_ctr",
        "placement_top_cr",
        "placement_top_cpc",
        "placement_top_cpa",
        "placement_top_acos",
        "placement_top_roas",
        "placement_product_page_spend",
        "placement_product_page_sale",
        "placement_product_page_orders",
        "placement_product_page_click",
        "placement_product_page_impression",
        "placement_product_page_ctr",
        "placement_product_page_cr",
        "placement_product_page_cpc",
        "placement_product_page_cpa",
        "placement_product_page_acos",
        "placement_product_page_roas",
        "placement_rest_spend",
        "placement_rest_sale",
        "placement_rest_orders",
        "placement_rest_click",
        "placement_rest_impression",
        "placement_rest_ctr",
        "placement_rest_cr",
        "placement_rest_cpc",
        "placement_rest_cpa",
        "placement_rest_acos",
        "placement_rest_roas",
        "placement_total_spend",
        "placement_total_sale",
        "placement_total_orders",
        "placement_total_click",
        "placement_total_impression",
        "placement_total_ctr",
        "placement_total_cr",
        "placement_total_cpc",
        "placement_total_cpa",
        "placement_total_acos",
        "placement_total_roas",
        "aov",
        "placement_buybox_spend",
        "placement_buybox_sale",
        "placement_buybox_orders",
        "placement_buybox_click",
        "placement_buybox_impression",
        "placement_buybox_ctr",
        "placement_buybox_cr",
        "placement_buybox_cpc",
        "placement_buybox_cpa",
        "placement_buybox_acos",
        "placement_buybox_roas",
        "placement_homepage_spend",
        "placement_homepage_sale",
        "placement_homepage_orders",
        "placement_homepage_click",
        "placement_homepage_impression",
        "placement_homepage_ctr",
        "placement_homepage_cr",
        "placement_homepage_cpc",
        "placement_homepage_cpa",
        "placement_homepage_acos",
        "placement_homepage_roas",
        "placement_searchingrid_spend",
        "placement_searchingrid_sale",
        "placement_searchingrid_orders",
        "placement_searchingrid_click",
        "placement_searchingrid_impression",
        "placement_searchingrid_ctr",
        "placement_searchingrid_cr",
        "placement_searchingrid_cpc",
        "placement_searchingrid_cpa",
        "placement_searchingrid_acos",
        "placement_searchingrid_roas",
        "placement_stockup_spend",
        "placement_stockup_sale",
        "placement_stockup_orders",
        "placement_stockup_click",
        "placement_stockup_impression",
        "placement_stockup_ctr",
        "placement_stockup_cr",
        "placement_stockup_cpc",
        "placement_stockup_cpa",
        "placement_stockup_acos",
        "placement_stockup_roas",
    ];

    const aggregatedData = calculateRatios(
        aggregateValues(currentRows, indexAttribute, AGGREGATED_COLUMNS),
        [
            "tacos",
            "previous_cr",
            "previous_ctr",
            "previous_cpc",
            "previous_cpa",
            "previous_acos",
            "previous_roas",
            "previous_troas",
            "previous_tacos",
            "previous_placement_top_ctr",
            "previous_placement_top_cr",
            "previous_placement_top_cpc",
            "previous_placement_top_cpa",
            "previous_placement_top_acos",
            "previous_placement_top_roas",
            "previous_placement_product_page_ctr",
            "previous_placement_product_page_cr",
            "previous_placement_product_page_cpc",
            "previous_placement_product_page_cpa",
            "previous_placement_product_page_acos",
            "previous_placement_product_page_roas",
            "previous_placement_rest_ctr",
            "previous_placement_rest_cr",
            "previous_placement_rest_cpc",
            "previous_placement_rest_cpa",
            "previous_placement_rest_acos",
            "previous_placement_rest_roas",
            "previous_placement_total_ctr",
            "previous_placement_total_cr",
            "previous_placement_total_cpc",
            "previous_placement_total_cpa",
            "previous_placement_total_acos",
            "previous_placement_total_roas",
            "previous_placement_buybox_ctr",
            "previous_placement_buybox_cr",
            "previous_placement_buybox_cpc",
            "previous_placement_buybox_cpa",
            "previous_placement_buybox_acos",
            "previous_placement_buybox_roas",
            "previous_placement_homepage_ctr",
            "previous_placement_homepage_cr",
            "previous_placement_homepage_cpc",
            "previous_placement_homepage_cpa",
            "previous_placement_homepage_acos",
            "previous_placement_homepage_roas",
            "previous_placement_searchingrid_ctr",
            "previous_placement_searchingrid_cr",
            "previous_placement_searchingrid_cpc",
            "previous_placement_searchingrid_cpa",
            "previous_placement_searchingrid_acos",
            "previous_placement_searchingrid_roas",
            "previous_placement_stockup_ctr",
            "previous_placement_stockup_cr",
            "previous_placement_stockup_cpc",
            "previous_placement_stockup_cpa",
            "previous_placement_stockup_acos",
            "previous_placement_stockup_roas",
        ]
    );

    return compareCurrentWithHistoricData(aggregatedData[""], keys);
};

type TRatios = {
    numerator: string;
    denominator: string;
    multiplier?: number;
};

export const RATIOS: Record<string, TRatios> = {
    tacos: { numerator: "spend", denominator: "total_sale", multiplier: 100 },
    ctr: { numerator: "click", denominator: "impression", multiplier: 100 },
    cr: { numerator: "orders", denominator: "click", multiplier: 100 },
    cpa: { numerator: "spend", denominator: "orders" },
    cpc: { numerator: "spend", denominator: "click" },
    aov: { numerator: "sale", denominator: "orders" },
    acos: { numerator: "spend", denominator: "sale", multiplier: 100 },
    roas: { numerator: "sale", denominator: "spend" },
    cpm: { numerator: "spend", denominator: "impression", multiplier: 1000 },
    troas: { numerator: "total_clicked_ad_sales", denominator: "spend" },
    placement_top_ctr: {
        numerator: "placement_top_click",
        denominator: "placement_top_impression",
        multiplier: 100,
    },
    placement_top_cr: {
        numerator: "placement_top_orders",
        denominator: "placement_top_click",
        multiplier: 100,
    },
    placement_top_cpa: {
        numerator: "placement_top_spend",
        denominator: "placement_top_orders",
    },
    placement_top_cpc: {
        numerator: "placement_top_spend",
        denominator: "placement_top_click",
    },
    placement_top_acos: {
        numerator: "placement_top_spend",
        denominator: "placement_top_sale",
        multiplier: 100,
    },
    placement_top_roas: {
        numerator: "placement_top_sale",
        denominator: "placement_top_spend",
    },
    placement_product_page_ctr: {
        numerator: "placement_product_page_click",
        denominator: "placement_product_page_impression",
        multiplier: 100,
    },
    placement_product_page_cr: {
        numerator: "placement_product_page_orders",
        denominator: "placement_product_page_click",
        multiplier: 100,
    },
    placement_product_page_cpa: {
        numerator: "placement_product_page_spend",
        denominator: "placement_product_page_orders",
    },
    placement_product_page_cpc: {
        numerator: "placement_product_page_spend",
        denominator: "placement_product_page_click",
    },
    placement_product_page_acos: {
        numerator: "placement_product_page_spend",
        denominator: "placement_product_page_sale",
        multiplier: 100,
    },
    placement_product_page_roas: {
        numerator: "placement_product_page_sale",
        denominator: "placement_product_page_spend",
    },
    placement_rest_ctr: {
        numerator: "placement_rest_click",
        denominator: "placement_rest_impression",
        multiplier: 100,
    },
    placement_rest_cr: {
        numerator: "placement_rest_orders",
        denominator: "placement_rest_click",
        multiplier: 100,
    },
    placement_rest_cpa: {
        numerator: "placement_rest_spend",
        denominator: "placement_rest_orders",
    },
    placement_rest_cpc: {
        numerator: "placement_rest_spend",
        denominator: "placement_rest_click",
    },
    placement_rest_acos: {
        numerator: "placement_rest_spend",
        denominator: "placement_rest_sale",
        multiplier: 100,
    },
    placement_rest_roas: {
        numerator: "placement_rest_sale",
        denominator: "placement_rest_spend",
    },
    placement_total_ctr: {
        numerator: "placement_total_click",
        denominator: "placement_total_impression",
        multiplier: 100,
    },
    placement_total_cr: {
        numerator: "placement_total_orders",
        denominator: "placement_total_click",
        multiplier: 100,
    },
    placement_total_cpa: {
        numerator: "placement_total_spend",
        denominator: "placement_total_orders",
    },
    placement_total_cpc: {
        numerator: "placement_total_spend",
        denominator: "placement_total_click",
    },
    placement_total_acos: {
        numerator: "placement_total_spend",
        denominator: "placement_total_sale",
        multiplier: 100,
    },
    placement_total_roas: {
        numerator: "placement_total_sale",
        denominator: "placement_total_spend",
    },
    placement_buybox_ctr: {
        numerator: "placement_buybox_click",
        denominator: "placement_buybox_impression",
        multiplier: 100,
    },
    placement_buybox_cr: {
        numerator: "placement_buybox_orders",
        denominator: "placement_buybox_click",
        multiplier: 100,
    },
    placement_buybox_cpa: {
        numerator: "placement_buybox_spend",
        denominator: "placement_buybox_orders",
    },
    placement_buybox_cpc: {
        numerator: "placement_buybox_spend",
        denominator: "placement_buybox_click",
    },
    placement_buybox_acos: {
        numerator: "placement_buybox_spend",
        denominator: "placement_buybox_sale",
        multiplier: 100,
    },
    placement_buybox_roas: {
        numerator: "placement_buybox_sale",
        denominator: "placement_buybox_spend",
    },
    placement_homepage_ctr: {
        numerator: "placement_homepage_click",
        denominator: "placement_homepage_impression",
        multiplier: 100,
    },
    placement_homepage_cr: {
        numerator: "placement_homepage_orders",
        denominator: "placement_homepage_click",
        multiplier: 100,
    },
    placement_homepage_cpa: {
        numerator: "placement_homepage_spend",
        denominator: "placement_homepage_orders",
    },
    placement_homepage_cpc: {
        numerator: "placement_homepage_spend",
        denominator: "placement_homepage_click",
    },
    placement_homepage_acos: {
        numerator: "placement_homepage_spend",
        denominator: "placement_homepage_sale",
        multiplier: 100,
    },
    placement_homepage_roas: {
        numerator: "placement_homepage_sale",
        denominator: "placement_homepage_spend",
    },
    placement_searchingrid_ctr: {
        numerator: "placement_searchingrid_click",
        denominator: "placement_searchingrid_impression",
        multiplier: 100,
    },
    placement_searchingrid_cr: {
        numerator: "placement_searchingrid_orders",
        denominator: "placement_searchingrid_click",
        multiplier: 100,
    },
    placement_searchingrid_cpa: {
        numerator: "placement_searchingrid_spend",
        denominator: "placement_searchingrid_orders",
    },
    placement_searchingrid_cpc: {
        numerator: "placement_searchingrid_spend",
        denominator: "placement_searchingrid_click",
    },
    placement_searchingrid_acos: {
        numerator: "placement_searchingrid_spend",
        denominator: "placement_searchingrid_sale",
        multiplier: 100,
    },
    placement_searchingrid_roas: {
        numerator: "placement_searchingrid_sale",
        denominator: "placement_searchingrid_spend",
    },
    placement_stockup_ctr: {
        numerator: "placement_stockup_click",
        denominator: "placement_stockup_impression",
        multiplier: 100,
    },
    placement_stockup_cr: {
        numerator: "placement_stockup_orders",
        denominator: "placement_stockup_click",
        multiplier: 100,
    },
    placement_stockup_cpa: {
        numerator: "placement_stockup_spend",
        denominator: "placement_stockup_orders",
    },
    placement_stockup_cpc: {
        numerator: "placement_stockup_spend",
        denominator: "placement_stockup_click",
    },
    placement_stockup_acos: {
        numerator: "placement_stockup_spend",
        denominator: "placement_stockup_sale",
        multiplier: 100,
    },
    placement_stockup_roas: {
        numerator: "placement_stockup_sale",
        denominator: "placement_stockup_spend",
    },
};

export const calculateRatio = (
    ratio: string,
    obj: Record<string, number>,
    prefix = ""
) => {
    const numerator = `${prefix ? `${prefix}_` : ``}${RATIOS[ratio].numerator}`;
    const denominator = `${prefix ? `${prefix}_` : ``}${
        RATIOS[ratio].denominator
    }`;
    const value =
        _.isNumber(obj[numerator]) &&
        _.isNumber(obj[denominator]) &&
        obj[numerator]
            ? obj[denominator]
                ? +(+(
                      (+obj[numerator] / +obj[denominator]) *
                      (RATIOS[ratio].multiplier || 1)
                  ).toFixed(2))
                : "Infinity"
            : 0.0;
    return value;
};

const calculateRatios = (
    result: Record<string, TCommonRowObj>,
    ratios: string[] = []
) =>
    _.mapObject(result, (val) => {
        const basicRatios = [
            "ctr",
            "cr",
            "cpc",
            "cpa",
            "cpm",
            "acos",
            "roas",
            "troas",
            "placement_top_ctr",
            "placement_top_cr",
            "placement_top_cpc",
            "placement_top_cpa",
            "placement_top_acos",
            "placement_top_roas",
            "placement_product_page_ctr",
            "placement_product_page_cr",
            "placement_product_page_cpc",
            "placement_product_page_cpa",
            "placement_product_page_acos",
            "placement_product_page_roas",
            "placement_rest_ctr",
            "placement_rest_cr",
            "placement_rest_cpa",
            "placement_rest_cpc",
            "placement_rest_acos",
            "placement_rest_roas",
            "placement_total_ctr",
            "placement_total_cr",
            "placement_total_cpc",
            "placement_total_cpa",
            "placement_total_acos",
            "placement_total_roas",
            "aov",
            "placement_buybox_acos",
            "placement_buybox_ctr",
            "placement_buybox_cr",
            "placement_buybox_cpc",
            "placement_buybox_cpa",
            "placement_buybox_roas",
            "placement_homepage_acos",
            "placement_homepage_ctr",
            "placement_homepage_cr",
            "placement_homepage_cpc",
            "placement_homepage_cpa",
            "placement_homepage_roas",
            "placement_searchingrid_acos",
            "placement_searchingrid_ctr",
            "placement_searchingrid_cr",
            "placement_searchingrid_cpc",
            "placement_searchingrid_cpa",
            "placement_searchingrid_roas",
            "placement_stockup_acos",
            "placement_stockup_ctr",
            "placement_stockup_cr",
            "placement_stockup_cpc",
            "placement_stockup_cpa",
            "placement_stockup_roas",
        ];
        const mergedRatios = [...basicRatios, ...ratios];

        const processedRatios = _.reduce(
            mergedRatios,
            (acc, ratio) =>
                (acc = {
                    ...acc,
                    [ratio]: 0.0,
                }),
            {}
        );

        const v = {
            ...val,
            ..._.reduce(
                mergedRatios,
                (acc, ratio) => {
                    let value: number | "Infinity" = 0;

                    const splittedRatio = ratio.split("_");
                    const attr = splittedRatio.pop();

                    if (RATIOS[attr]) {
                        value = calculateRatio(
                            attr,
                            val as Record<string, number>,
                            splittedRatio.join("_")
                        );
                    }
                    return {
                        ...acc,
                        [ratio]: value,
                    };
                },
                processedRatios
            ),
        };
        return v;
    });

const calculateChangePerc = (
    newData: number,
    oldData: number,
    isPercent = true
) =>
    typeof newData === "number"
        ? isPercent
            ? oldData && oldData && typeof oldData === "number"
                ? +((+(newData / oldData) - 1) * 100).toFixed(2)
                : null
            : +(newData || 0) -
              +(oldData && oldData && typeof oldData === "number" ? oldData : 0)
        : 0;

const compareCurrentWithHistoricData = (row: TCommonRowObj, keys: string[]) => {
    const response = JSON.parse(JSON.stringify(row));
    for (const attr of keys) {
        response[`${attr}_change`] = calculateChangePerc(
            row[attr] as number,
            row[`previous_${attr}`] as number,
            !_.contains(
                [
                    "impression_share_rank",
                    "rank",
                    "bsr",
                    "price",
                    "rating",
                    "rating_count",
                ],
                attr
            )
        );
    }
    return response;
};

function aggregateValues(
    rows: TCommonRowData,
    indexAttributes: Array<string>,
    aggregateAttributes: Array<string>
) {
    const attributes = _.reduce(
        aggregateAttributes,
        (acc, ind: string) =>
            (acc = {
                ...acc,
                [ind]: 0,
                [`previous_${ind}`]: 0,
            }),
        {}
    );

    const data = _.reduce(
        rows,
        (acc: Record<string, TCommonRowObj>, i: TCommonRowObj) => {
            const index: string = indexAttributes.length
                ? _.map(indexAttributes, (key: string) => i[key]).join("##")
                : "";

            const filteredObject = {
                ...i,
                ...attributes,
            };

            if (!acc[index]) {
                acc[index] = filteredObject;
            }

            // eslint-disable-next-line @typescript-eslint/no-shadow
            _.mapObject(attributes, (_, a) => {
                acc[index] = {
                    ...acc[index],
                    ...(i && { [a]: +(acc[index][a] || 0) + +(i[a] || 0) }),
                };
            });
            return acc;
        },
        {}
    );

    return data;
}

onmessage = (event) => postMessage(aggregatedSumTotalRow(event.data));